<template>
<div>
  <e-chart ref="chart" />
</div>
</template>

<script>
import EChart from '../../../../../components/Charts/ECharts'
export default {
  name: 'FactorSourceStackChart',
  components: {EChart},
  props: {
    sourceNameConfigs: {
      required: true,
      type: Array
    },
    dataMap: {
      required: true,
      type: Object
    },
    dataTimeFormatter: {
      required: true,
      type: String
    }
  },
  methods: {
    renderChart () {
      const {dataMap, sourceNameConfigs, dataTimeFormatter} = this
      const dataTimes = Object.keys(dataMap)
      const chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        legend: {},
        grid: {
          top: 40,
          right: 40,
          bottom: 40,
          left: 60,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dataTimes.map(dataTime => new Date(dataTime).format(dataTimeFormatter)),
          splitLine: {
            show: false
          },
          axisLine: {
            // onZero: false
          },
          axisLabel: {
            // rotate: 90
          }
        },
        yAxis: {
          type: 'value',
          name: `μg/m3`,
          nameLocation: 'center',
          nameGap: 40,
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            onZero: false
          },
          axisTick: {
            show: true
          }
        },
        series: sourceNameConfigs.map(sourceNameConfig => ({
          name: sourceNameConfig.name,
          type: 'bar',
          color: sourceNameConfig.color,
          stack: 'source',
          barMaxWidth: 30,
          data: dataTimes.map(dataTime => {
            const data = dataMap[dataTime]
            return data ? data[sourceNameConfig.id] : null
          })
        }))
      }

      this.$refs.chart.setOpt(chartOpt, true)
    }
  },
  mounted () {
    setTimeout(() => {
      this.renderChart()
    }, 0)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/FactorSourceStackChart.vue